import { GameFacade } from "../facade-scene/facade-scene";
import { SceneDataInterface } from "../../interfaces/scene-data-interface";
import { EndSceneElementsSpecifications } from "./end-scene-elements-specifications";
import { GameSceneIdsStrings } from "../../settings/game-constants-strings/game-scene-ids-string";
import { ButtonComponent } from "../../components/button-component/button-component";
import { EventsTouchedGameObjectsStrings } from "../../settings/game-constants-strings/game-events-strings";
import { GameSceneElementsString } from "../../settings/game-constants-strings/game-elements-strings";
import { ColorsValue } from "../../settings/game-constants-strings/text-styles-string";

export class EndScene extends Phaser.Scene {

    private gameFacade: GameFacade;
    private sceneGameObjects;
    private sceneData: SceneDataInterface;
    
    private sceneBackground: Phaser.GameObjects.Image;
    private quitButton: ButtonComponent;
    private continueButton: ButtonComponent;

    init(_sceneData: SceneDataInterface) {
        this.sceneData = _sceneData;
    }

    constructor() {
        super({
            key: GameSceneIdsStrings.END_SCENE_ID
        });
        this.sceneGameObjects = new Map();
    }

    create() {  
        this.generateScene();
        this.getElements();
        this.addFunctionality();
    }

    private generateScene() {
        this.gameFacade = new GameFacade(this, EndSceneElementsSpecifications);
        this.sceneGameObjects = this.gameFacade.getGameObjects;
    }

    private getElements() {
        this.sceneBackground = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_BACKGROUND
        ).gameObject;
        this.sceneBackground.setTint(ColorsValue.BLACK_HEXADECIMAL_VALUE);

        this.quitButton = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_QUIT_BUTTON
        ).gameObject;

        this.continueButton = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_CONTINUE_BUTTON
        ).gameObject;

        const totalScoreText = this.sceneGameObjects.get(
            GameSceneElementsString.SCENE_TOTAL_SCORE
        ).gameObject;
        totalScoreText.setText(this.sceneData.totalScore);
    }

    private addFunctionality() {
        // addTintOnGameButton(this.closeButton);
        this.quitButton.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                // this.scene.stop(GameSceneIdsStrings.MAIN_SCENE_ID);
                this.scene.start(GameSceneIdsStrings.START_SCENE_ID);
            }
        );
        this.continueButton.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                this.scene.start(GameSceneIdsStrings.MAIN_SCENE_ID);
                // this.scene.stop(this.scene.key);

                // setTimeout(() => {
                // this.sceneData.isReset = true;
                // this.scene.launch(GameSceneIdsStrings.MAIN_SCENE_ID, this.sceneData);
                // }, 10);
            }
        );
    }
}